import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const keepOnlyOneOpen = true
    const preventClosingLastOne = false
    const activeClass = 'accordion--active'

    const nodeSelectors = {
        container: '[js-block-logo-slider="container"]',
        slider: '[js-block-logo-slider="slider"]',
        pagination: '[js-block-logo-slider="pagination"]'
    }

    const containers = scope.querySelectorAll(nodeSelectors.container)

    if (!containers.length) return

    containers.forEach((container) => {
        const sliderEl = container.querySelector(nodeSelectors.slider);
        if (!sliderEl) return;

        // Destroy existing swiper instance before re-init
        if (sliderEl.swiper) {
            sliderEl.swiper.destroy(true, true);
        }

        const settings = {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            speed: 300,
            navigation: {
                nextEl: container.querySelector(nodeSelectors.next),
                prevEl: container.querySelector(nodeSelectors.prev),
            },
            pagination: {
                el: container.querySelector(nodeSelectors.pagination),
                clickable: true,
            },
            breakpoints: {
                300: {
                    slidesPerView: 2,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 4
                },
                1100: {
                    slidesPerView: 6
                }
            }
        };

        new Swiper(sliderEl, settings);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if ( window.acf ) {
        // Only in block editor preview
        window.acf.addAction('render_block_preview/type=logo-slider', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if( !isGutenbergEditorVisible() ) {
        // Only in frontend
        init()
    }
});